import React from 'react';

const STATUS_STYLES = {
  draft: 'bg-gray-100 text-gray-700 border-gray-200',
  pending_approval: 'bg-yellow-100 text-yellow-700 border-yellow-200',
  approved: 'bg-blue-100 text-blue-700 border-blue-200', // <-- Added: Style for Approved badge [1]
  published: 'bg-green-100 text-green-700 border-green-200',
  archived: 'bg-red-100 text-red-700 border-red-200',
};

const STATUS_LABELS = {
  draft: 'Draft',
  pending_approval: 'Pending Approval',
  approved: 'Approved', // <-- Added: Label for Approved state [1]
  published: 'Published',
  archived: 'Archived',
};

const PolicyStatusBadge = ({ status }) => {
  const style = STATUS_STYLES[status] || STATUS_STYLES.draft;
  const label = STATUS_LABELS[status] || status;
  return (
    <span className={`px-3 py-1 text-xs font-medium rounded-full border ${style}`}>
      {label}
    </span>
  );
};

export default PolicyStatusBadge;
